import { render, staticRenderFns } from "./SocialNetwork.vue?vue&type=template&id=8d7dae00&scoped=true&ref=adminUser&"
import script from "./SocialNetwork.vue?vue&type=script&lang=js&"
export * from "./SocialNetwork.vue?vue&type=script&lang=js&"
import style0 from "./SocialNetwork.vue?vue&type=style&index=0&id=8d7dae00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7dae00",
  null
  
)

export default component.exports